import React from 'react';
import { FaUserClock } from 'react-icons/fa';
import { useAuthStore } from '../store';

// Staff/admin roles sign back in at /staff; guests at /login.
const STAFF_ROLES = ['global_admin', 'org_admin', 'admin', 'employee'];

function loginPathForRole() {
  const role = localStorage.getItem('user_role') || useAuthStore.getState().user?.role;
  return STAFF_ROLES.includes(role) ? '/staff' : '/login';
}

/**
 * Global, non-dismissable modal shown when the session has expired (an
 * unrecoverable 401). It replaces the raw API error spam with a single clean
 * prompt. The only way out is to sign in again, which does a full navigation so
 * all stale in-flight requests and component state are discarded.
 */
export default function SessionExpiredModal() {
  const sessionExpired = useAuthStore((s) => s.sessionExpired);
  if (!sessionExpired) return null;

  const handleReLogin = () => {
    const target = loginPathForRole();
    // Clear any lingering credentials and route state, then hard-navigate for a
    // clean slate (discards the never-settling promises from the interceptor).
    localStorage.removeItem('access_token');
    localStorage.removeItem('refresh_token');
    localStorage.removeItem('user_role');
    useAuthStore.getState().logout();
    window.location.assign(target);
  };

  return (
    <div
      className="fixed inset-0 z-[200] bg-black/55 backdrop-blur-sm flex items-center justify-center p-4"
      role="dialog"
      aria-modal="true"
      aria-labelledby="session-expired-title"
    >
      <div className="bg-white rounded-lg shadow-2xl w-full max-w-sm overflow-hidden">
        <div className="flex items-start gap-4 px-5 pt-5 pb-4">
          <div className="h-11 w-11 rounded-lg bg-amber-50 flex items-center justify-center flex-shrink-0">
            <FaUserClock size={18} className="text-amber-500" />
          </div>
          <div className="min-w-0 flex-1">
            <h3 id="session-expired-title" className="text-base font-bold text-gray-900">
              Session timed out
            </h3>
            <p className="text-sm text-gray-500 mt-1 leading-relaxed">
              For your security, your session has expired. Please sign in again to continue.
            </p>
          </div>
        </div>

        <div className="border-t border-gray-100 px-5 py-4">
          <button
            type="button"
            onClick={handleReLogin}
            className="w-full bg-teal-700 text-white rounded-md py-2.5 text-sm font-bold hover:bg-teal-800 transition shadow-sm"
          >
            Sign in again
          </button>
        </div>
      </div>
    </div>
  );
}
